import request from '@/plugin/axios'

export function pageList(query) {
return request({
url: '/api/admin/signature/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/signature',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/signature/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/signature/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/signature/' + id,
method: 'put',
data: obj
})
}
